"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.setEmail = exports.setName = exports.setPhone = exports.userSlice = exports.USER_COOKIE_NAME = void 0;
const InputPhone_1 = require("@portalterreno/react-ui-core/InputPhone");
const toolkit_1 = require("@reduxjs/toolkit");
const cookies_next_1 = require("cookies-next");
exports.USER_COOKIE_NAME = 'p-user';
const initialState = {
    email: {
        isValid: true,
        value: ''
    },
    name: {
        isValid: true,
        value: ''
    },
    phone: {
        country: InputPhone_1.countries.find((country) => country.alphaCode2 === process.env.NEXT_PUBLIC_COUNTRY.toUpperCase()),
        formattedValue: '',
        isValid: true,
        value: ''
    }
};
exports.userSlice = (0, toolkit_1.createSlice)({
    name: 'user',
    initialState: () => {
        let cachedValues = {};
        const userInformation = (0, cookies_next_1.getCookie)(exports.USER_COOKIE_NAME);
        if (typeof userInformation === 'string') {
            cachedValues = JSON.parse(userInformation);
        }
        return {
            ...initialState,
            ...cachedValues
        };
    },
    reducers: {
        setPhone: (state, action) => {
            state.phone = action.payload;
        },
        setName: (state, action) => {
            state.name = action.payload;
        },
        setEmail: (state, action) => {
            state.email = {
                ...state.email,
                ...action.payload
            };
        }
    }
});
_a = exports.userSlice.actions, exports.setPhone = _a.setPhone, exports.setName = _a.setName, exports.setEmail = _a.setEmail;
exports.default = exports.userSlice.reducer;
//# sourceMappingURL=slice.js.map